/* eslint-disable react-hooks/exhaustive-deps */
import { Box, CircularProgress } from '@mui/material'
import DashboardContainer from 'components/smart/dashboard-container/DashboardContainer'
import { authContext } from 'contexts/AuthContext'
import React, { useContext, useEffect } from 'react'
import { useState } from 'react'
import { useQuery, useQueryClient } from 'react-query'
import {
  getActiveAppraisalResult,
  getAllAppraisalResult,
} from 'services/api/modules/performance/appraisal/result'
import PActiveList from '../components/PActiveList'
import PCompletedList from '../components/PCompletedList'

const PerformanceDashboard = () => {
  const { auth } = useContext(authContext)
  const queryClient = useQueryClient()
  const [activeAppraisal, setActiveAppraisal] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [staffId, setStaffId] = useState()
  const hasRoles = auth?.data?.staff?.roles

  useEffect(() => {
    queryClient.invalidateQueries('activeResult')
    queryClient.resetQueries('activeResult')
  }, [])

  const { isLoading } = useQuery(
    ['activeResult', staffId],
    async () => {
      const { data } = await getActiveAppraisalResult(staffId)

      setActiveAppraisal(data?.data)
      return data
    },
    {
      enabled: !!staffId,
    }
  )

  const { data, isLoading: isLoadingCompleted } = useQuery(
    ['completedResult', currentPage],
    async () => {
      const { data } = await getAllAppraisalResult(staffId, currentPage)
      return data
    },
    {
      enabled: !!staffId,
    }
  )

  const results = data?.data

  useEffect(() => {
    queryClient.invalidateQueries('completedResult')
    queryClient.resetQueries('completedResult')
  }, [currentPage])

  useEffect(() => {
    if (auth?.data?.staff?.id) {
      setStaffId(auth?.data?.staff?.id)
    }
  }, [auth])

  return (
    <DashboardContainer headerTitle="Appraisal">
      {isLoading ? (
        <Box height="70vh" display="flex" justifyContent="center" alignItems="center">
          <CircularProgress color="alternate" size={60} />
        </Box>
      ) : (
        <Box display="flex" flexDirection="column" gap={2}>
          {activeAppraisal?.length !== 0 && (
            <PActiveList
              staffId={staffId}
              appraisalData={activeAppraisal}
              isLoading={isLoading}
              hasRoles={hasRoles}
            />
          )}
          <PCompletedList
            staffId={staffId}
            appraisalData={results ?? []}
            isLoading={isLoadingCompleted}
            hasRoles={hasRoles}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            data={data}
          />
        </Box>
      )}
    </DashboardContainer>
  )
}

export default PerformanceDashboard
